import {SaveCancelFooter} from '@/components-v2'
import {useProductComboFooter} from '@/hooks/productCombo/useProductComboFooter'

export const ProductComboFooter = () => {
  const {
    handleNextAction,
    handleCancelAction,
    handleDraftAction,
    isReview,
    hasValidationErrors,
    hideSaveDraft,
    isLoading,
  } = useProductComboFooter()

  return (
    <SaveCancelFooter
      handleCancel={handleCancelAction}
      draftAction={handleDraftAction}
      nextAction={handleNextAction}
      isReview={isReview}
      hideSaveDraft={hideSaveDraft}
      FormError={hasValidationErrors}
      isLoading={isLoading}
    />
  )
}
